const form = document.getElementById('login') as HTMLFormElement;
const error = document.getElementById('error')!;

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  const data = new FormData(form);
  const button = form.querySelector('button')!;
  button.disabled = true;
  error.hidden = true;
  try {
    const res = await fetch('/api/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: data.get('username'), password: data.get('password') }),
    });
    if (res.ok) {
      location.replace('/');
      return;
    }
    const body = (await res.json().catch(() => ({}))) as { error?: string };
    error.textContent = body.error ?? `Sign-in failed (HTTP ${res.status}).`;
  } catch {
    error.textContent = 'Cannot reach the server. Check your connection and try again.';
  }
  error.hidden = false;
  button.disabled = false;
});
